import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { isLeftClickEvent, isModifiedEvent } from 'helpers/EventHelpers';

export const MartyLink = (props, { router }) => {
  const { onClick, ...rest } = props;

  const handleClick = e => {
    const { target, to } = props;

    if (onClick) {
      onClick(e);
    }

    if (!isLeftClickEvent(e) || isModifiedEvent(e) || e.defaultPrevented || target) {
      return;
    }

    e.preventDefault();
    router.pushPreserveAppRoot(to);
  };

  return <Link onClick={handleClick} {...rest}/>;
};

MartyLink.contextTypes = {
  router: PropTypes.object.isRequired
};

MartyLink.propTypes = {
  to: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

export default MartyLink;
